import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, ViewChild } from '@angular/core';
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { DataService } from 'src/app/services/data.service';
import { MessageService } from 'src/app/services/message.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-human-personnel-form',
  templateUrl: './human-personnel-form.component.html',
  styleUrls: ['./human-personnel-form.component.css'],
})
export class HumanPersonnelFormComponent {
  @ViewChild('fileInput') fileInputRef: ElementRef;
  @ViewChild('fileInputTwo') fileInputRefTwo: ElementRef;
  @ViewChild('fileInputThree') fileInputRefThree: ElementRef;
  @ViewChild('fileInputFour') fileInputRefFour: ElementRef;
  @ViewChild('fileInputFive') fileInputRefFive: ElementRef;

  url: string = 'personnel';
  id!: string;
  form!: FormGroup;
  roles: Array<any> = [];
  departments: Array<any> = [];
  backgrounds: Array<any> = [];
  modalities: Array<any> = [];
  step = 1;
  files: any = [];
  //nameFile!: string;
  apiUrl = environment.apiUrl;
  //imagePreviews: { [key: string]: string } = {};
  uploadStatus = {
    contract: false,
    nda: false,
    licensesMedical: false,
    insurance: false,
    licensesLeave: false,
  };
  contractLink: string = '';
  ndaLink: string = '';
  licensesMedicalLink: string = '';
  insuranceLink: string = '';
  licensesLeaveLink: string = '';
  indicatives: Array<any> = [];
  countries: Array<any> = [];
  showModal = false;
  imgModal: string;
  showModalImg = false;
  imgUser: string;
  fullname: string;
  update = false;
  data: Array<any> = [];
  searchText = '';
  filteredData: Array<any> = [];
  sugerenciasBusqueda: string[] = [];
  currentPage: number = 1;
  morePages: boolean = true;
  itemsPerPage: number = 15;
  isLoading = false;
  resumenCards = [
    {
      label: '',
      value: 0,
      icon: 'fas fa-users',
      bgClass: 'bg-white',
      desc: 'Staff &+',
      //route: null,
      route: '/humanResources',
    },
    {
      label: '',
      value: 0,
      icon: 'fas fa-city',
      bgClass: 'bg-white',
      desc: 'Toolkit',
      route: '/humanResources/toolkit',
    },
  ];

  constructor(
    private dataService: DataService,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private messageService: MessageService,
    private http: HttpClient
  ) {
    this.form = this.fb.group({
      user: ['', [Validators.required]],
      firstname: ['', [Validators.required]],
      lastname: ['', [Validators.required]],
      username: ['', [Validators.required]],
      title: ['', [Validators.required]],
      identification: ['', [Validators.required]],
      rut: ['', [Validators.required]],
      status: [''],
      phone: ['', [Validators.required]],
      indicative: [''],
      address: ['', [Validators.required]],
      apt: [''],
      city: ['', [Validators.required]],
      state: ['', [Validators.required]],
      country: ['', [Validators.required]],
      img: [''],
      //comments: [''],
      role: ['', [Validators.required]],
      department: ['', [Validators.required]],
      compliance: this.fb.group({
        contract: [''],
        nda: [''],
        //licenses: [''],
        licenses: this.fb.array([]),
        insurance: [''],
        startContract: [''],
        endContract: [''],
        verifiedBy: [''],
        background: [''],
        legalStatus: [''],
      }),
      availability: this.fb.group({
        workingDays: [''],
        modality: [''],
        schedule: [''],
        ticketRegistration: [''],
        recordedAbsences: [''],
        vacation: [''],
        licenses: [''],
        observations: [''],
      }),
      evaluation: this.fb.group({
        scheduled: [''],
        lastEvaluation: [''],
        nextEvaluation: [''],
        evaluator: [''],
        score: [''],
        achievements: [''],
        areasImprovement: [''],
        comments: [''],
        activeGoals: [''],
        completedGoals: [''],
        alerts: [''],
        metrics: [''],
      }),
      salary: this.fb.group({
        paymentMethod: [''],
        currentSalary: [''],
        receipts: [''],
        bonuses: [''],
        paymentHistory: [''],
        salaryIncreases: [''],
        increaseDate: [''],
        previousSalary: [''],
        newSalary: [''],
        authorizedBy: [''],
        reason: [''],
        comments: [''],
      }),
    });
  }

  ngOnInit(): void {
    this.selectDataRoles();
    this.route.params.subscribe((params: Params) => {
      this.id = params['id'];

      if (this.id) {
        this.getData();
      }
    });

    this.departments = ['Development', 'Finance', 'Logistics', 'Dispatch'];
    this.backgrounds = ['Yes', 'No', 'Under review'];
    this.modalities = ['On-site', 'Hybrid ', 'Remote'];
    this.indicatives = [
      '+1',
      '+57',
      '+52',
      '+55',
      '+54',
      '+56',
      '+58',
      '+34',
      '+44',
    ];

    this.cities();

    const currentPath = this.router.url.split('/')[2];
    console.log('path:', currentPath);

    if (currentPath === 'freelancers') {
      this.step = 2;
    } else if (currentPath === 'drivers') {
      this.step = 3;
    } else if (currentPath === 'customers') {
      this.step = 4;
    } else {
      this.step = 1;
    }
  }

  isFieldInvalid(field: string) {
    return (
      this.form.get(field)?.invalid &&
      (this.form.get(field)?.dirty || this.form.get(field)?.touched)
    );
  }

  onSubmit(): void {
    if (this.id) {
      this.updateData();
    } else {
      this.createData();
    }
  }

  getData(): void {
    this.dataService.getData(`${this.url}/${this.id}`).subscribe((response) => {
      console.log('response data', response);
      this.form.patchValue({
        user: response.user._id,
        firstname: response.user.firstname,
        lastname: response.user.lastname,
        username: response.user.username,
        title: response.user.title,
        identification: response.user.identification,
        rut: response.user.rut,
        status: response.user.status,
        phone: response.user.phone,
        indicative: response.user.indicative,
        img: response.user.img,
        address: response.user.address,
        apt: response.user.apt,
        city: response.user.city,
        state: response.user.state,
        country: response.user.country,
        //comments: response.user.comments,
        role: response.user.role,
        department: response.user.department,
      });

      this.fullname = response.user.firstname + ' ' + response.user.lastname;

      (this.form.get('compliance') as FormGroup).patchValue({
        contract: response.compliance.contract,
        nda: response.compliance.nda,
        insurance: response.compliance.insurance,
        startContract: response.compliance.startContract,
        endContract: response.compliance.endContract,
        verifiedBy: response.compliance.verifiedBy,
        background: response.compliance.background,
        legalStatus: response.compliance.legalStatus,
      });

      const licensesArray = this.form.get('compliance.licenses') as FormArray;
      while (licensesArray.length) {
        licensesArray.removeAt(0);
      }

      /* response.compliance.licenses?.forEach((license: any) => {
        licensesArray.push(license);
      }); */
      response.compliance.licenses?.forEach((license: any) => {
        licensesArray.push(new FormControl(license));
      });

      if (response.availability) {
        (this.form.get('availability') as FormGroup).patchValue({
          workingDays: response.availability.workingDays,
          modality: response.availability.modality,
          schedule: response.availability.schedule,
          ticketRegistration: response.availability.ticketRegistration,
          recordedAbsences: response.availability.recordedAbsences,
          vacation: response.availability.vacation,
          licenses: response.availability.licenses,
          observations: response.availability.observations,
        });
      }

      if (response.evaluation) {
        (this.form.get('evaluation') as FormGroup).patchValue({
          scheduled: response.evaluation.scheduled,
          lastEvaluation: response.evaluation.lastEvaluation,
          nextEvaluation: response.evaluation.nextEvaluation,
          evaluator: response.evaluation.evaluator,
          score: response.evaluation.score,
          achievements: response.evaluation.achievements,
          areasImprovement: response.evaluation.areasImprovement,
          comments: response.evaluation.comments,
          activeGoals: response.evaluation.activeGoals,
          completedGoals: response.evaluation.completedGoals,
          alerts: response.evaluation.alerts,
          metrics: response.evaluation.metrics,
        });
      }

      if (response.salary) {
        (this.form.get('salary') as FormGroup).patchValue({
          paymentMethod: response.salary.paymentMethod,
          currentSalary: response.salary.currentSalary,
          receipts: response.salary.receipts,
          bonuses: response.salary.bonuses,
          paymentHistory: response.salary.paymentHistory,
          salaryIncreases: response.salary.salaryIncreases,
          increaseDate: response.salary.increaseDate,
          previousSalary: response.salary.previousSalary,
          newSalary: response.salary.newSalary,
          authorizedBy: response.salary.authorizedBy,
          reason: response.salary.reason,
          comments: response.salary.comments,
        });
      }
      this.imgUser = response.user.img
        ? `${this.apiUrl}/uploads/${response.user.img}`
        : './assets/img/faces/marc.jpg';
    });
  }

  createData(): void {
    /* const formData = {
      ...this.form.value,
    }; */
    const dataForm = new FormData();

    /* Object.entries(this.form.value).forEach(([key, value]) => {
      if (value !== null && value !== undefined) {
        dataForm.append(key, value as any);
      }
    }); */

    Object.entries(this.form.value).forEach(([key, value]) => {
      if (value !== null && value !== undefined) {
        if (typeof value === 'object') {
          dataForm.append(key, JSON.stringify(value));
        } else {
          dataForm.append(key, value as any);
        }
      }
    });

    if (this.files?.length) {
      this.files.forEach((fileObj) => {
        dataForm.append('files', fileObj.file);
      });
    }

    console.log('form', this.form.value);

    this.dataService
      .postData(`${this.url}/add`, dataForm)
      .subscribe((response) => {
        console.log('response', response);
        if (response.rst) {
          //this.messageService.add(response.msg, 'info');
          this.form.reset();
          this.router.navigateByUrl('/humanResources/personnel');
        } else {
          this.messageService.add(response.msg, 'secondary');
        }
      });
  }

  updateData(): void {
    this.isLoading = true;
    /* const formData = {
      ...this.form.value,
    }; */

    const dataForm = new FormData();

    /* Object.entries(this.form.value).forEach(([key, value]) => {
      if (value !== null && value !== undefined) {
        dataForm.append(key, value as any);
      }
    }); */
    Object.entries(this.form.value).forEach(([key, value]) => {
      if (value !== null && value !== undefined) {
        if (typeof value === 'object') {
          dataForm.append(key, JSON.stringify(value));
        } else {
          dataForm.append(key, value as any);
        }
      }
    });

    if (this.files?.length) {
      this.files.forEach((fileObj) => {
        dataForm.append('files', fileObj.file);
      });
    }

    this.dataService
      .putData(`${this.url}/edit/${this.id}`, dataForm)
      .subscribe((response) => {
        if (response.rst) {
          //this.messageService.add(response.msg, 'info');
          this.form.reset();
          //this.router.navigateByUrl('/numbers/accounting');
          this.isLoading = false;
          this.router.navigateByUrl('/humanResources');
        } else {
          this.messageService.add(response.msg, 'secondary');
        }
      });
  }

  selectDataRoles(): void {
    this.dataService.getData('roles/select').subscribe((response) => {
      console.log('response.data', response);
      //this.roles = response.data;
      this.roles = response.data.filter(
        (role: any) =>
          role.name.toLowerCase() !== 'driver' &&
          role.name.toLowerCase() !== 'client'
        //role.name.toLowerCase() !== 'admin'
      );
    });
  }

  openEmail(email: string) {
    if (!email) return;

    const subject = encodeURIComponent('Contacto desde sistema');
    const body = encodeURIComponent(
      'Hola,\n\nMe comunico contigo desde el sistema.\n\nSaludos.'
    );
    //const gmailComposeUrl = `https://mail.google.com/mail/?view=cm&fs=1&to=${email}&su=${subject}&body=${body}`;
    const gmailComposeUrl = `https://mail.google.com/mail/?view=cm&fs=1&to=${email}`;

    const chooserUrl = `https://accounts.google.com/AccountChooser?continue=${encodeURIComponent(
      gmailComposeUrl
    )}`;

    window.open(chooserUrl, '_blank');
  }

  changeStep(step: number) {
    this.step = step;
  }

  /* selectFile() {
    this.fileInputRef.nativeElement.click();
  }

  selectFileTwo() {
    this.fileInputRefTwo.nativeElement.click();
  }

  selectFileThree() {
    this.fileInputRefTwo.nativeElement.click();
  }

  captureFile(event: any) {
    const original_file: File = event.target.files[0];

    if (!original_file) return;

    const timestamp = Date.now();
    const new_name = `${timestamp}-${original_file.name}`;

    const file = new File([original_file], new_name, {
      type: original_file.type,
      lastModified: original_file.lastModified,
    });

    let nameFile = file.name;
    console.log('nameFile:', nameFile);
    //this.files.push(file);
    this.upload = true;
    (this.form.get('compliance') as FormGroup).patchValue({
      contract: nameFile,
    });
    this.updateFileList(file, 'contract');
    this.previewFile(file, 'contract');
  }

  captureFileTwo(event: any) {
    const original_file: File = event.target.files[0];

    if (!original_file) return;

    const timestamp = Date.now();
    const new_name = `${timestamp}-${original_file.name}`;

    const file = new File([original_file], new_name, {
      type: original_file.type,
      lastModified: original_file.lastModified,
    });

    let nameFile = file.name;
    console.log('nameFile:', nameFile);
    //this.files.push(file);
    this.upload_two = true;
    (this.form.get('compliance') as FormGroup).patchValue({
      nda: nameFile,
    });
    this.updateFileList(file, 'nda');
    this.previewFile(file, 'nda');
  }

  captureFileThree(event: any) {
    const original_file: File = event.target.files[0];

    if (!original_file) return;

    const timestamp = Date.now();
    const new_name = `${timestamp}-${original_file.name}`;

    const file = new File([original_file], new_name, {
      type: original_file.type,
      lastModified: original_file.lastModified,
    });

    let nameFile = file.name;
    console.log('nameFile:', nameFile);
    //this.files.push(file);
    this.upload_three = true;
    (this.form.get('compliance') as FormGroup).patchValue({
      licenses: nameFile,
    });
    this.updateFileList(file, 'licensesMedical');
    this.previewFile(file, 'licensesMedical');
  } */

  /* selectFile(ref: ElementRef) {
    ref.nativeElement.click();
  } */

  selectFile(ref: string) {
    if (ref == 'fileInput') {
      this.fileInputRef.nativeElement.click();
    } else if (ref == 'fileInputTwo') {
      this.fileInputRefTwo.nativeElement.click();
    } else if (ref == 'fileInputThree') {
      this.fileInputRefThree.nativeElement.click();
    } else if (ref == 'fileInputFour') {
      this.fileInputRefFour.nativeElement.click();
    }
  }

  /* captureFile(
    event: any,
    fieldKey: string,
    formKey: string,
    formGroupKey: string
  ) {
    const original_file: File = event.target.files[0];
    if (!original_file) return;

    const timestamp = Date.now();
    const new_name = `${timestamp}-${original_file.name}`;
    const file = new File([original_file], new_name, {
      type: original_file.type,
      lastModified: original_file.lastModified,
    });

    const nameFile = file.name;
    console.log('nameFile:', nameFile);

    // Activar bandera de carga
    this.uploadStatus[fieldKey] = true;

    // Actualizar el formulario
    (this.form.get([formGroupKey]) as FormGroup).patchValue({
      [formKey]: nameFile,
    });

    this.updateFileList(file, fieldKey);
    //this.previewFile(file, fieldKey);
  } */

  captureFile(
    event: any,
    fieldKey: string,
    formKey: string,
    formGroupKey: string
  ) {
    const original_file: File = event.target.files[0];
    if (!original_file) return;

    const timestamp = Date.now();
    const new_name = `${timestamp}-${original_file.name}`;
    const file = new File([original_file], new_name, {
      type: original_file.type,
      lastModified: original_file.lastModified,
    });

    const nameFile = file.name;
    console.log('Archivo capturado:', nameFile);

    this.uploadStatus[fieldKey] = true;

    const group = this.form.get(formGroupKey);

    if (group instanceof FormGroup) {
      const control = group.get(formKey);

      if (control instanceof FormArray) {
        //  Si es un array, agregamos un nuevo control con el nombre del archivo
        control.push(this.fb.control(nameFile));
      } else if (control instanceof FormControl) {
        //  Si es un control normal, simplemente actualizamos su valor
        control.setValue(nameFile);
      } else {
        console.warn(`No se encontró el control ${formKey} en ${formGroupKey}`);
      }
    } else {
      console.warn(`No se encontró el grupo ${formGroupKey}`);
    }

    this.updateFileList(file, fieldKey);
  }

  pru() {
    console.log('form', this.form.value);
  }

  updateFileList(file: File, fieldKey: string) {
    const index = this.files.findIndex((f) => f.fieldKey === fieldKey);
    if (index !== -1) {
      this.files[index] = { file, fieldKey }; // reemplazar si ya existe
    } else {
      this.files.push({ file, fieldKey }); // agregar si no existe
    }
  }

  /* previewFile(file: File, fieldKey: string) {
    const reader = new FileReader();
    reader.onload = () => {
      //this.previewUrl = reader.result as string; // Guardar el preview
      this.imagePreviews[fieldKey] = reader.result as string;
    };
    reader.readAsDataURL(file);
  } */

  /* removeFile(fieldKey: string) {
    console.log('this.files', this.files);
    this.files = this.files.filter((f) => f.fieldKey !== fieldKey);
    delete this.imagePreviews[fieldKey];

    //console.log('this.files', this.files);
    //console.log('this.imagePreviews', this.imagePreviews);

    if (fieldKey === 'contract') {
      this.uploadStatus.contract = false;
      (this.form.get('compliance') as FormGroup).patchValue({
        contract: '',
      });
    } else if (fieldKey === 'nda') {
      this.uploadStatus.nda = false;
      (this.form.get('compliance') as FormGroup).patchValue({
        nda: '',
      });
    } else if (fieldKey === 'licensesMedical') {
      this.uploadStatus.licensesMedical = false;
      (this.form.get('compliance') as FormGroup).patchValue({
        licenses: '',
      });
    }
  } */
  removeFile(fieldKey: string, formKey: string, formGroupKey: string) {
    this.files = this.files.filter((f) => f.fieldKey !== fieldKey);
    //delete this.imagePreviews[fieldKey];

    this.uploadStatus[fieldKey] = false;

    (this.form.get([formGroupKey]) as FormGroup).patchValue({
      [formKey]: '',
    });
  }

  contractUrl() {
    const contract = this.form.get('compliance.contract')?.value;
    console.log('Valor de contract:', contract);
    console.log('img contract', contract);
    this.contractLink = contract ? `${this.apiUrl}/uploads/${contract}` : '';
    /* return img
      ? `${this.apiUrl}/uploads/${img}`
      : './assets/img/faces/marc.jpg'; */
  }

  ndaUrl() {
    const nda = this.form.get('compliance.nda')?.value;
    console.log('Valor de contract:', nda);
    console.log('img nda', nda);
    this.ndaLink = nda ? `${this.apiUrl}/uploads/${nda}` : '';
    /* return img
    ? `${this.apiUrl}/uploads/${img}`
    : './assets/img/faces/marc.jpg'; */
  }

  /* licensesMedicalUrl() {
    const licensesMedical = this.form.get('compliance.licenses')?.value;
    console.log('Valor de licensesMedical:', licensesMedical);
    console.log('img licensesMedical', licensesMedical);
    this.licensesMedicalLink = licensesMedical
      ? `${this.apiUrl}/uploads/${licensesMedical}`
      : '';
    //return img
    //? `${this.apiUrl}/uploads/${img}`
    //: './assets/img/faces/marc.jpg';
  } */

  licensesMedicalUrl(licensesMedical: string) {
    console.log('Valor de licensesMedical:', licensesMedical);
    console.log('img licensesMedical', licensesMedical);
    this.licensesMedicalLink = licensesMedical
      ? `${this.apiUrl}/uploads/${licensesMedical}`
      : '';
    //return img
    //? `${this.apiUrl}/uploads/${img}`
    //: './assets/img/faces/marc.jpg';
  }

  openModal() {
    this.showModal = true;
  }

  insuranceUrl() {
    const insurance = this.form.get('compliance.insurance')?.value;
    console.log('Valor de insurance:', insurance);
    console.log('img insurance', insurance);
    this.insuranceLink = insurance ? `${this.apiUrl}/uploads/${insurance}` : '';
    /* return img
    ? `${this.apiUrl}/uploads/${img}`
    : './assets/img/faces/marc.jpg'; */
  }

  licensesLeaveUrl() {
    const licensesLeave = this.form.get('availability.licenses')?.value;
    console.log('Valor de licensesLeave:', licensesLeave);
    console.log('img licensesLeave', licensesLeave);
    this.licensesLeaveLink = licensesLeave
      ? `${this.apiUrl}/uploads/${licensesLeave}`
      : '';
    /* return img
    ? `${this.apiUrl}/uploads/${img}`
    : './assets/img/faces/marc.jpg'; */
  }

  cities() {
    this.http
      .get('https://restcountries.com/v3.1/all?fields=name')
      .subscribe((data: any[]) => {
        this.countries = data;
        this.countries = data.map((el) => el.name.common);
        this.countries.sort((a, b) => a.localeCompare(b));

        console.log('countries', this.countries);

        // Establecer "United States" como valor predeterminado si existe
        const EEUU = this.countries.find(
          (name) => name.toLowerCase() === 'united states'
        );

        //console.log('EEUU',EEUU)
        /* if (EEUU) {
          this.data.country = EEUU;
        } */
      });
  }
  /* 
  formatPhone() {
    const phoneNumber = (this.form.get('phone')?.value || '').replace(
      /[^\d]/g,
      ''
    );

    const phoneNumberLength = (this.form.get('phone')?.value || '').length;
    console.log('logitud');
    console.log(phoneNumberLength);
    if (phoneNumberLength <= 3) {
      //this.data.phone = phoneNumber.slice(0, 3);
      this.form.patchValue({
        phone: phoneNumber.slice(0, 3),
      });
    } else if (phoneNumberLength == 4) {
      //this.data.phone =        '(' + phoneNumber.slice(0, 3) + ') ' + phoneNumber.slice(3, 4);
      this.form.patchValue({
        phone: '(' + phoneNumber.slice(0, 3) + ') ' + phoneNumber.slice(3, 4),
      });
    } else if (phoneNumberLength == 5) {
      //this.data.phone = '(' + phoneNumber.slice(0, 3);
      this.form.patchValue({
        phone: '(' + phoneNumber.slice(0, 3),
      });
    } else if (phoneNumberLength == 6) {
      //this.data.phone =        '(' + phoneNumber.slice(0, 3) + ') ' + phoneNumber.slice(3, 6);
      //console.log(this.data.phone);
      this.form.patchValue({
        phone: '(' + phoneNumber.slice(0, 3) + ') ' + phoneNumber.slice(3, 6),
      });
    } else if (phoneNumberLength == 7) {
      //this.data.phone =        '(' + phoneNumber.slice(0, 3) + ') ' + phoneNumber.slice(3, 6);
      this.form.patchValue({
        phone: '(' + phoneNumber.slice(0, 3) + ') ' + phoneNumber.slice(3, 6),
      });
    } else if (phoneNumberLength == 8) {
      //this.data.phone =        '(' + phoneNumber.slice(0, 3) + ') ' + phoneNumber.slice(3, 6);
      this.form.patchValue({
        phone: '(' + phoneNumber.slice(0, 3) + ') ' + phoneNumber.slice(3, 6),
      });
    } else if (phoneNumberLength == 9) {
      //this.data.phone =        '(' + phoneNumber.slice(0, 3) + ') ' + phoneNumber.slice(3, 6);
      this.form.patchValue({
        phone: '(' + phoneNumber.slice(0, 3) + ') ' + phoneNumber.slice(3, 6),
      });
    } else if (phoneNumberLength == 10) {
      //this.data.phone = '(' + phoneNumber.slice(0, 3) +   ') ' + phoneNumber.slice(3, 6) + ' - ' + phoneNumber.slice(6, 10);
      this.form.patchValue({
        phone:
          '(' +
          phoneNumber.slice(0, 3) +
          ') ' +
          phoneNumber.slice(3, 6) +
          ' - ' +
          phoneNumber.slice(6, 10),
      });
    }
  }
 */

  formatPhone(event: Event) {
    const input = event.target as HTMLInputElement;

    let digits = input.value.replace(/\D/g, '');
    digits = digits.slice(0, 10);

    let formatted = '';
    if (digits.length <= 3) {
      formatted = digits;
    } else if (digits.length <= 6) {
      formatted = `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
    } else {
      formatted = `(${digits.slice(0, 3)}) ${digits.slice(
        3,
        6
      )} - ${digits.slice(6)}`;
    }

    this.form.get('phone')?.setValue(formatted, { emitEvent: false });
  }

  get licenses() {
    return this.form.get('compliance.licenses') as FormArray;
  }

  closeModal() {
    this.showModal = false;
  }

  get userImgUrl(): string {
    const img = this.form.get('img')?.value;

    return img
      ? `${this.apiUrl}/uploads/${img}`
      : './assets/img/faces/marc.jpg';
  }

  openModalImg(img: string) {
    console.log('img', img);
    this.showModalImg = true;

    if (img == 'imgUser') {
      this.imgModal = this.imgUser;
      console.log('imgUser en modal', this.imgUser);
    }
  }

  closeModalImg() {
    this.showModalImg = false;
    this.imgModal = '';
  }

  enableUpdate() {
    this.update = !this.update;
  }

  filterInfo() {
    const texto = this.searchText.trim().toLowerCase();
    //console.log('texto',texto);
    if (!texto) {
      this.filteredData = [...this.data];
    } else {
      this.filteredData = this.data.filter((item) => {
        return (
          (item.firstname && item.firstname.toLowerCase().includes(texto)) ||
          (item.lastname && item.lastname.toLowerCase().includes(texto))
          //(item.phone && item.phone.toLowerCase().includes(texto)) ||
          //(item.role &&
          //  item.role.name &&
          //  item.role.name.toLowerCase().includes(texto)) ||
          //(item.rol_user && item.rol_user.toLowerCase().includes(texto)) ||
          //(item.state && item.state.toLowerCase().includes(texto)) ||
          //(item.city && item.city.toLowerCase().includes(texto))
        );
      });
      //console.log('filteredData',this.filteredData);
    }
  }
}
